import { gql } from "@apollo/client";
import moment from 'moment';

export const GET_JUSTIFICACIONES_EXPORT = gql`
query justificacionesExport($tipoJustificacion: String!, 
                            $idEvaluacion: Int!,
                            $idOrdenPedido: Int!,
                            $idEstadoComercial: Int!,
                            $idEstadoMedico: Int!,
                            $idEstadoBUM: Int!) {
    exportarJustificaciones(input: {
                        tipoJustificacion: $tipoJustificacion,
                        idEvaluacion: $idEvaluacion,
                        idOrdenPedido: $idOrdenPedido,
                        idEstadoComercial: $idEstadoComercial,
                        idEstadoMedico: $idEstadoMedico,
                        idEstadoBUM: $idEstadoBUM                        
                    })
    {
        success,
        error,
        valorEsperado {
            tipoJustificacion,
            idEvaluacion,
            idOrdenPedido,
            diasCondiContrato,
            diasMaxFactCliente,
            descDelegacion,
            idPaciente,
            paciente,
            cobertura,
            planCuidado,
            descEstadoComercial,
            descEstadoMedico,
            descEstadoBUM,
            descJustificadoComercial,
            descJustificadoMedico,
            descJustificadoBUM,
            descDelegacion,
            obsComercial,
            obsMedico,
            obsBUM,
            fechaComercial,
            fechaMedico,
            fechaBUM,
            contratosCO,
            fechaAlta
        }
    }
}`;

export const adaptJustificacionToExport = (justificacion) => ({
  Delegacion: justificacion.descDelegacion,
  Tipo: justificacion.tipoJustificacion,
  Contrato: justificacion.idEvaluacion,
  Pedido: justificacion.idOrdenPedido,
  DiasCO: justificacion.diasCondiContrato,
  ContratosCO: justificacion.contratosCO,
  DiasCliente: justificacion.diasMaxFactCliente,
  HC: justificacion.idPaciente,
  Paciente: justificacion.paciente,
  Cobertura: justificacion.cobertura,
  Plan: justificacion.planCuidado,
  EstadoComercial: justificacion.descEstadoComercial,
  JustificadoComercial: justificacion.descJustificadoComercial,
  ObsComercial: justificacion.obsComercial,
  FechaComercial: justificacion.fechaComercial ? moment(justificacion.fechaComercial).format('DD/MM/yyyy') : '',
  EstadoMedico: justificacion.descEstadoMedico,
  JustificadoMedico: justificacion.descJustificadoMedico,
  ObsMedico: justificacion.obsMedico,
  FechaMedico: justificacion.fechaMedico ? moment(justificacion.fechaMedico).format('DD/MM/yyyy') : '',
  EstadoBUM: justificacion.descEstadoBUM,
  JustificadoBUM: justificacion.descJustificadoBUM,
  ObsBUM: justificacion.obsBUM,
  FechaBUM: justificacion.fechaBUM ? moment(justificacion.fechaBUM).format('DD/MM/yyyy') : '',
  FechaAlta: justificacion.fechaAlta ? moment(justificacion.fechaAlta).format('DD/MM/yyyy') : ''
});

export const adaptJustificacionesToExportArray = (justificaciones) =>
structuredClone(justificaciones)?.
map((justificacion) => adaptJustificacionToExport(justificacion));